import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import { FooterCommonLink } from '@cat-ecom/pcc-components';
import Conditional from '@app/components/common/Conditional';
import cx from 'classnames';
const CatSiteLinks = ({ isFooterDesignUpdate, isMobile }) => {
  const menuItems = useSelector(s => s.header?.waffle?.menuItems);

  return (
    <Conditional test={isMobile} fallback={null}>
      {menuItems?.map(item => (
        <div className={cx('d-flex', 'flex-column', 'mb-4', 'gap-4')}>
          <FooterCommonLink
            isMobile={isMobile}
            key={item?.appId}
            isFooterDesignUpdate={isFooterDesignUpdate}
            label={item?.appLabel}
            href={item?.appUrl}
            target={'_self'}
          />
        </div>
      ))}
    </Conditional>
  );
};

export default CatSiteLinks;

CatSiteLinks.propTypes = {
  isFooterDesignUpdate: PropTypes.bool,
  isMobile: PropTypes.bool
};
CatSiteLinks.defaultProps = {
  isFooterDesignUpdate: false,
  isMobile: false
};
